(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["appointment-request-new"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('meridian-appointment-form')) {
    customElements.define('meridian-appointment-form', class extends HTMLElement {
      connectedCallback() {
        const form = this.querySelector('form');
        if (!form || this.controller) return;
        this.controller = new AbortController();
        form.addEventListener('submit', (event) => {
          if (form.querySelector('[data-appointment-honeypot]')?.value) { event.preventDefault(); return; }
          const name = form.querySelector('[data-appointment-name]');
          if (name) name.value = [form.querySelector('[data-appointment-first]')?.value.trim(), form.querySelector('[data-appointment-last]')?.value.trim()].filter(Boolean).join(' ');
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
